import React, { Component } from 'react';
import { Button, Row, Col, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import 'react-block-ui/style.css';
import { connect } from 'react-redux';
import { compose } from 'redux';

class SessionClosedNotification extends Component {

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg" backdrop="static">

                    <Modal.Header>
                        <Modal.Title><FontAwesomeIcon icon={duotone("triangle-exclamation")} /> {this.props.t("sessionclosed")}</Modal.Title>
                        <OverlayTrigger
                            placement="left"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("close")}
                            </Tooltip>}>
                            <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                        </OverlayTrigger>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>{this.props.t(this.props.message)}</Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {};
};
export default compose(connect(mapStateToProps, {}), withTranslation())(SessionClosedNotification);